import { useState, useEffect } from 'react';
import dayjs from 'dayjs'
import ReactLoading from 'react-loading';

import CourbeServiceHome from '../components/CourbeService/CourbeServiceHome.js'
import KPICard from '../components/Dashboard/KPICard.js';
import MiniGraph from '../components/Dashboard/MiniGraph.js';
import { reduceTotalValues } from '../helpers/routeOperationHelpers.js'
import { formatData } from '../helpers/serviceCurveHelpers.js'

import optc from '../optc.json'

import {
  getUser,
  getUserAgency,
  getAllAgencies,
  getRouteOperation,
  getPlanTripCumul,
  curveSingle,
  //getValuesPrevious,
  getValuesYesterday,
  getGlobalStats,
  getLastWeekBenchmarks,
  getVehAndOcc
} from '../API';

import { useTranslation } from "react-i18next";


const Home = () => {

  const [t] = useTranslation('common');

  const [agency, setAgency] = useState('');
  const [userAgency, setUserAgency] = useState('');
  const [loading, setLoading] = useState(0);

  //const [dataArray, setDataArray] = useState('');

  //GlobalKPIs
  const [globalTrips, setGlobalTrips] = useState(0);
  const [globalKms, setGlobalKms] = useState(0);
  const [globalHours, setGlobalHours] = useState(0);
  const [globalVeh, setGlobalVeh] = useState(0);
  const [globalOtp, setGlobalOtp] = useState(0);
  const [globalOcc, setGlobalOcc] = useState(0);

  //WeekKPIs
  const [weekKpis, setWeekKpis] = useState([]);

  //TodayKPIs
  const [reduced, setReduced] = useState('');
  const [planTrips, setPlanTrips] = useState('');
  const [planKms, setPlanKms] = useState('');
  const [planHours, setPlanHours] = useState('');
  const [realTrips, setRealTrips] = useState('');
  const [realKms, setRealKms] = useState('');
  const [realHours, setRealHours] = useState('');
  const [vehicles, setVehicles] = useState('');
  const [occ, setOcc] = useState('');
  const [otp, setOtp] = useState('');

  //YesterdayKPIs
  const [planTripsYesterday, setPlanTripsYesterday] = useState('');
  const [planKmsYesterday, setPlanKmsYesterday] = useState('');
  const [planHoursYesterday, setPlanHoursYesterday] = useState('');
  const [realTripsYesterday, setRealTripsYesterday] = useState('');
  const [realKmsYesterday, setRealKmsYesterday] = useState('');
  const [realHoursYesterday, setRealHoursYesterday] = useState('');
  const [vehiclesYesterday, setVehiclesYesterday] = useState('');
  const [occYesterday, setOccYesterday] = useState('');
  const [otpYesterday, setOtpYesterday] = useState('');

  //ServiceCurve today
  const [serviceCurve, setServiceCurve] = useState('');
  const [plannedCurve, setPlannedCurve] = useState('');

  //ServiceCurve yesterday
  const [serviceCurveYesterday, setServiceCurveYesterday] = useState('');
  const [plannedCurveYesterday, setPlannedCurveYesterday] = useState('');

  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {

    getUserAgency().then(response => {
      setUserAgency(response);
      setAgency(response[0]);
    })
  }, []);


  useEffect(() => {

    setLoading(1);

    //Today KPIs
    getRouteOperation(agency)
      .then(response => {

        let dataReduced = reduceTotalValues(response)[0];

        setReduced(dataReduced);

        setRealTrips(dataReduced.realTrips);
        setRealKms(dataReduced.realKM.toFixed(0));
        setRealHours(dataReduced.realDuration.toFixed(0));

        return Promise.all([
          dataReduced
        ])
      }).then(([
        dataReduced
      ]) => {
        setLoading(0);
      }).catch(error => {
        // Handle error if any of the async operations fail
        console.error("Error:", error);
      });

    getPlanTripCumul(agency)
      .then(response => {
        setPlanTrips(response[0].plantripcount);
        setPlanKms(response[0].plandist);
        setPlanHours(response[0].planduration);
      })

    let today = dayjs().format('YYYY-MM-DD');
    let yesterday = dayjs().add(-1, 'day').format('YYYY-MM-DD');


    //Yesterday KPIs
    let previous = 1;

    getValuesYesterday(agency, yesterday, today, previous)
      .then((valuesResponse) => {

        if (valuesResponse.length != 0) {
          setPlanTripsYesterday(valuesResponse[0].plannedtrips);
          setPlanKmsYesterday(valuesResponse[0].plannedvehkms);
          setPlanHoursYesterday(valuesResponse[0].plannedvehhours);
          setRealTripsYesterday(valuesResponse[0].rttrips);
          setRealKmsYesterday(valuesResponse[0].rtvehkms);
          setRealHoursYesterday(valuesResponse[0].rtvehhours);
          setVehiclesYesterday(valuesResponse[0].vehnum);
          setOccYesterday(valuesResponse[0].occavg);
          setOtpYesterday(valuesResponse[0].otpavg);
        }

      })
      .catch(error => {
        // Handle error if any of the async operations fail
        console.error("Error:", error);
      });

  }, [refreshKey]);


  useEffect(() => {

    //Service curve today
    let date = new Date();

    curveSingle(date, agency, 0).then((result) => {

      let formattedData = formatData(result, agency);

      setServiceCurve(formattedData[0]);
      setPlannedCurve(formattedData[1]);

    });

    //Service curve yesterday
    let dateYesterday = new Date();
    dateYesterday.setDate(dateYesterday.getDate() - 1);

    curveSingle(dateYesterday, agency, 1).then((result) => {

      let formattedData = formatData(result, agency);

      setServiceCurveYesterday(formattedData[0]);
      setPlannedCurveYesterday(formattedData[1]);

    })


  }, [refreshKey]);


  useEffect(() => {

    getGlobalStats(agency).then((response) => {
      setGlobalTrips(response[0].tripspct);
      setGlobalKms(response[0].kmpct);
      setGlobalHours(response[0].hourspct);
      setGlobalVeh(response[0].veh);
      setGlobalOtp(response[0].otp);
      setGlobalOcc(response[0].occ);
    })

    //Veh and occupation for today
    getVehAndOcc(agency).then(response => {
      setOcc(response[0].occavg);
      setVehicles(response[0].vehnum);
    });

  }, [refreshKey])


  useEffect(() => {

    // Graphs hebdos
    getLastWeekBenchmarks(agency)
      .then(response => {

        response.forEach((e) => {
          e.ontimeperformance = e.ontimeperformance * 100
        })

        let weekChoice = response;

        if (weekChoice.length != 0) {
          let kpiKeys = Object.keys(weekChoice[0]);
          kpiKeys.splice(0, 4);
          kpiKeys.pop();
          let index = kpiKeys.indexOf("rtstoptimes");
          let x = kpiKeys.splice(index, 1);
          setWeekKpis(weekChoice);
        }

      });
  }, [refreshKey]);


  function handleAgencySelect(e) {
    setAgency(e.target.value);
    setRefreshKey(oldKey => oldKey + 1);
    setPlanTrips('');
    setPlanKms('');
    setPlanHours('');
    setLoading(1);
  }

  return userAgency && serviceCurve ? (

    <>

      <div className="row">
        <div className="col text-center">
          <h1 id="page-title" className="display-5">{t("home.title")}</h1>
          <h3>{optc.optc.find((e) => e.operateur == userAgency[0]).nom}</h3>
          {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="row justify-content-center mb-2">
            <h3 id="page-subtitle" className="display-5"><b>{agency != '' ? agency.toUpperCase() : userAgency[0].toUpperCase()}</b> </h3>
          </div> : ''}
        </div>
      </div>

      <div className="container" style={{ backgroundColor: "#f8f9fa" }}>

        <div className="row justify-content-center pt-3">
          <div className="col-lg col-sm-12 text-center">

            {userAgency.length > 1 ?
              <div className="me-1 border rounded ps-2 pe-2" style={{ backgroundColor: "white" }}>
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-sm-12">
                    <select onChange={(event) => handleAgencySelect(event)} className="form-select form-select-lg mb-3 mt-3">
                      <option defaultValue>{t("home.op")}</option>
                      {userAgency.map((e) => (
                        <option value={e} key={e}
                        >{e}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              : ''}

          </div>
        </div>

        <div className="row justify-content-center home-section-heading">
          <h3 className="text-center display-7">{t("home.title1")}</h3>
        </div>

        {/* GLOBAL KPIS */}
        <div className="row row-cols-1 row-cols-md-3 g-4 pb-3">
          <KPICard
            kpi={(globalTrips !== null && globalTrips !== 0 ) ? globalTrips.toFixed(1) + '%' : t('data.loading')}
            desc={<><div>{t("home.kpi.trips")}</div></>}
          />
          <KPICard
            kpi={globalTrips !== null && globalKms !== 0 ? globalKms.toFixed(1) + '%' : t('data.loading')}
            desc={<><div>{t("home.kpi.km")}</div></>}
          />
          <KPICard
            kpi={globalTrips !== null && globalHours !== 0 ? globalHours.toFixed(1) + '%' : t('data.loading')}
            desc={<><div>{t("home.kpi.hours")}</div></>}
          />
          <KPICard
            kpi={globalTrips !== null && globalOcc !== 0 ? globalOcc.toFixed(3) : t('home.na')}
            desc={<><div>{t("home.kpi.load")}</div></>}
          />
          <KPICard
            kpi={globalTrips !== null && globalOtp !== 0 ? globalOtp.toFixed(1) + '%' : t('data.loading')}
            desc={<><div>{t("home.kpi.otp")}</div></>}
          />
          <KPICard
            kpi={globalTrips !== null && globalVeh !== 0 ? globalVeh.toFixed(0) : t('data.loading')}
            desc={<><div>{t("home.kpi.vehicles")}</div></>}
          />
        </div>


        {/* LAST WEEK KPIS */}
        <div className="row justify-content-center pt-3 pb-2">
          <h3 className="text-center display-7">{t("dashboard.subtitle2")}</h3>
        </div>

        <div className="row chart-row">
          <MiniGraph
            kpi={t("dashboard.graphs.trips")}
            data={weekKpis}
            dataKey1="plannedtrips"
            name1={t("dashboard.graphs.planned")}
            dataKey2="rttrips"
            name2={t("dashboard.graphs.real")}
            xAxisKey="datetxt"
          />

          <MiniGraph
            kpi={t("dashboard.graphs.title.vehkm")}
            data={weekKpis}
            dataKey1="plannedvehkms"
            name1={t("dashboard.graphs.planned")}
            dataKey2="rtvehkms"
            name2={t("dashboard.graphs.real")}
            xAxisKey="datetxt"
          />

          <MiniGraph
            kpi={t("dashboard.graphs.title.vehh")}
            data={weekKpis}
            dataKey1="plannedvehhours"
            name1={t("dashboard.graphs.planned")}
            dataKey2="rtvehhours"
            name2={t("dashboard.graphs.real")}
            xAxisKey="datetxt"
          />

          <MiniGraph
            kpi={t("dashboard.graphs.load")}
            data={weekKpis}
            dataKey1=""
            name1=""
            dataKey2="occupancyaverage"
            name2={t("dashboard.graphs.real1")}
            xAxisKey="datetxt"
          />

          <MiniGraph
            kpi={t("dashboard.graphs.otp")}
            data={weekKpis}
            dataKey1=""
            name1=""
            dataKey2="ontimeperformance"
            name2={t("dashboard.graphs.real1")}
            xAxisKey="datetxt"
          />

          <MiniGraph
            kpi={t("dashboard.graphs.vehicles")}
            data={weekKpis}
            dataKey1=""
            name1=""
            dataKey2="vehicles"
            name2={t("dashboard.graphs.real")}
            xAxisKey="datetxt"
          />

        </div>


        <div className="row justify-content-center home-section-heading">
          <h3 className="text-center display-7">{t("home.title2")}</h3>
        </div>

        {/* TODAY KPIS */}              
        <div className="row row-cols-1 row-cols-md-3 g-4 pb-3">
          <KPICard
            kpi={realTrips && planTrips ? parseFloat(realTrips / planTrips * 100).toFixed(1) + '%' : t("home.loading")}
            desc={<><div>{t("home.kpi.trips")}</div><div>{
              realTrips && planTrips ? realTrips + ' / ' + planTrips : t("home.loadingsimple")}</div></>}
          />
          <KPICard
            kpi={realKms && planKms ? parseFloat(realKms / planKms * 100).toFixed(1) + '%' : t("home.loading")}
            desc={<><div>{t("home.kpi.km")}</div>
              <div>{realKms && planKms ?
                realKms + ' / ' + parseFloat(planKms).toFixed(0) : t("home.loadingsimple")}</div>
            </>}
          />
          <KPICard
            kpi={realHours && planHours ? parseFloat(realHours / planHours * 100).toFixed(1) + '%' : t("home.loading")}
            desc={<><div>{t("home.kpi.hours")}</div>
              <div>{realHours && planHours ?
                realHours + ' / ' + parseFloat(planHours).toFixed(0) : t("home.loadingsimple")}</div></>}
          />
          <KPICard
            kpi={occ && occ > 0 ? parseFloat(occ).toFixed(3) : t("home.na")}
            desc={<><div>{t("home.kpi.load")}</div>
            </>}
          />
          <KPICard
            kpi={otp ? parseFloat(otp).toFixed(1) + '%' : t("home.na")}
            desc={<><div>{t("home.kpi.otp")}</div>
            </>}
          />
          <KPICard
            kpi={vehicles ? vehicles : t("home.na")}
            desc={<><div>{t("home.kpi.vehicles")}</div>
            </>}
          />
        </div>

        {loading == 0 ? '' :
          <div className="homespinner">
            <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
          </div>}

        {serviceCurve ?
          <div className="row no-gutters align-items-center justify-content-center pb-2 pt-2">
            <div className="col-12">
              <div className="border rounded" style={{ backgroundColor: "white" }}>
                <CourbeServiceHome
                  realtimeData={serviceCurve[0].data}
                  plannedData={plannedCurve[0].data}
                />
              </div >
            </div>
          </div>
          : ''}

        <div className="row justify-content-center home-section-heading">
          <h3 className="text-center display-7">{t("home.title3")}</h3>
        </div>

        {/* YESTERDAY KPIS */}      
        <div className="row row-cols-1 row-cols-md-3 g-4 pb-3">
          <KPICard
            kpi={realTripsYesterday && planTripsYesterday ? parseFloat(realTripsYesterday / planTripsYesterday * 100).toFixed(1) + '%' : t("home.loading")}
            desc={<><div>{t("home.kpi.trips")}</div><div>{
              realTripsYesterday && planTripsYesterday ? realTripsYesterday + ' / ' + planTripsYesterday : t("home.loadingsimple")}</div></>}
          />
          <KPICard
            kpi={realKmsYesterday && planKmsYesterday ? parseFloat(realKmsYesterday / planKmsYesterday * 100).toFixed(1) + '%' : t("home.loading")}
            desc={<><div>{t("home.kpi.km")}</div>
              <div>{realKmsYesterday && planKmsYesterday ?
                realKmsYesterday + ' / ' + parseFloat(planKmsYesterday).toFixed(0) : t("home.loadingsimple")}</div>
            </>}
          />
          <KPICard
            kpi={realHoursYesterday && planHoursYesterday ? parseFloat(realHoursYesterday / planHoursYesterday * 100).toFixed(1) + '%' : t("home.loading")}
            desc={<><div>{t("home.kpi.hours")}</div>
              <div>{realHoursYesterday && planHoursYesterday ?
                realHoursYesterday + ' / ' + parseFloat(planHoursYesterday).toFixed(0) : t("home.loadingsimple")}</div></>}
          />
          <KPICard
            kpi={occYesterday && occYesterday > 0 ? parseFloat(occYesterday).toFixed(3) : t("home.na")}
            desc={<><div>{t("home.kpi.load")}</div>
            </>}
          />
          <KPICard
            kpi={otpYesterday ? parseFloat(otpYesterday).toFixed(1) + '%' : t("home.na")}
            desc={<><div>{t("home.kpi.otp")}</div>
            </>}
          />
          <KPICard
            kpi={vehiclesYesterday ? vehiclesYesterday : t("home.na")}
            desc={<><div>{t("home.kpi.vehicles")}</div>
            </>}
          />
        </div>

        {serviceCurveYesterday ?
          <div className="row no-gutters align-items-center justify-content-center pb-3">
            <div className="col-12">
              <div className="border rounded" style={{ borderColor: "black", backgroundColor: "white" }}>
                <CourbeServiceHome
                  realtimeData={serviceCurveYesterday[0].data}
                  plannedData={plannedCurveYesterday[0].data}
                />
              </div >
            </div>
          </div>
          : ''}

      </div>

    </>
  ) :
    <div className="container" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="d-flex justify-content-center">
        <div className="row">
          <div className="col-sm">
            <h1 className="display-5">{t('home.loading')}</h1>
            <div className="d-flex justify-content-center">
              <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
            </div>
          </div>
        </div>
      </div>
    </div>

}

export default Home;